import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { CsrAddComponent } from '../csr-add/csr-add.component';
import { RemarksComponent } from '../../../events/remarks/remarks.component';
declare let $: any;
@Component({
  selector: 'app-csr-list',
  templateUrl: './csr-list.component.html',
  styleUrls: ['./csr-list.component.css'],
})
export class CsrListComponent implements OnInit {
  displayedColumns: string[] = [
    'index',
    'projectName',
    'spocName',
    'spocMobile',
    'status',
    'remark',
    'action',
  ];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  private baseUrl = environment.url;
  private listApi = `${this.baseUrl}csrproject/list`;
  private deleteApi = environment.url + environment.eventDelete;
  /**
   * Constructs an instance of the component.
   * @param router The router used to navigate to different routes.
   * @param makeapi The API service used to make API calls.
   * @param getdata The service used to get the values of the session storage.
   * @param http The HTTP client used to make HTTP requests.
   * @param notify The service used to show notifications.
   * @param dialog The dialog service used to open dialogs.
   */
  constructor(
    private router: Router,
    private makeapi: ApiService,
    private getdata: ValueService,
    private http: HttpClient,
    private notify: NotifyService,
    public dialog: MatDialog
  ) {
    /**
     * The data source for the table.
     * An instance of MatTableDataSource.
     */
    this.dataSource = new MatTableDataSource();
  }
  roleValue;
  /**
   * Called when the component is initialized.
   * Sets the `isVisibleSource` subject of the `ValueService` to `true`.
   * Sets the `roleValue` property to the value of the `role` key in the session storage.
   * Sets the `valueGet` property to 'all' and calls the `ststusBtn` method with the arguments `3` and 'all'.
   */
  ngOnInit(): void {
    this.getdata.isVisibleSource.next(true);
    this.roleValue = sessionStorage.getItem('role');
    $('.all').addClass('btnActive');
    this.valueGet = 'all';
    this.ststusBtn(3, 'all');
  }
  /**
   * This method makes an API call to fetch the list of CSR projects.
   * It calls the `csrproject/save` endpoint.
   * @returns An Observable of an array of CSR project objects.
   */
  getCsrProjects(): Observable<any[]> {
    const url = `${this.baseUrl}/csrproject/save`;
    return this.http.get<any[]>(url);
  }
  /**
   * Navigate to the home page.
   */
  dataclick() {
    this.router.navigateByUrl('/home');
  }

  list = {};
  disList: any = [];
  pageTotalCount: number;
  pageSize: number = 10;
  pageNumber: number = 1;
  noData = true;
  /**
   * Retrieves the list of CSR projects from the API.
   * Updates the component data by calling the ListApi method.
   */
  csrList() {
    /**
     * The parameters to be sent to the API.
     * listSize: The size of the list per page.
     * pageNumber: The current page number.
     */
    this.list = {
      listSize: this.pageSize,
      pageNumber: this.pageNumber,
    };
    /**
     * Calls the ListApi method to fetch the data from the API.
     * Subscribes to the API response and updates the component data.
     */
    this.ListApi();
  }
  /**
   * Fetches the list of CSR projects from the API.
   * Subscribes to the API response and updates the component data.
   * @returns An observable containing the response from the API
   */
  ListApi() {
    this.makeapi
      .method(this.listApi, this.list, 'post')
      .subscribe((data: any) => {
        /**
         * If no data is returned, sets the noData flag to true.
         * Otherwise, sets the pageTotalCount and disList properties with the data from the API.
         * Updates the MatTableDataSource with the new data.
         */
        if (data.count == 0) {
          this.noData = true;
        } else {
          this.noData = false;
          this.pageTotalCount = data.count;
          this.disList = data.responsemodelList;

          this.dataSource = new MatTableDataSource(data.responsemodelList);
        }
      });
  }
  /**
   * Lifecycle hook that is called after the component's view has been fully initialized.
   * Sets the paginator for the MatTableDataSource.
   */
  ngAfterViewInit() {
    // Set the paginator for the MatTableDataSource
    this.dataSource.paginator = this.paginator;
  }
  /**
   * Handles the pagination events.
   * Updates the component data based on the current page index and page size.
   * @param event - The pagination event containing the page index and page size.
   */
  getServerData(event) {
    // Update the page number and page size
    this.pageNumber = event.pageIndex + 1;
    this.pageSize = event.pageSize;

    // Filter the data based on the selected status
    if (this.valueGet != 3) {
      // Create the request parameters for the API call
      this.list = {
        listSize: this.pageSize,
        pageNumber: this.pageNumber,
        status: this.valueGet,
      };
    } else {
      // Create the request parameters for the API call
      this.list = {
        listSize: this.pageSize,
        pageNumber: this.pageNumber,
      };

      // Call the API to fetch the updated data
      this.ListApi();
    }
  }
  /**
   * Opens a dialog to add a new CSR project or edit an existing one.
   * @param value - The title of the dialog (e.g. 'Add' or 'Edit').
   * @param id - The ID of the CSR project to edit.
   */
  editEvent(value: string, id: number) {
    const dialogRef = this.dialog.open(CsrAddComponent, {
      /**
       * The data object to be passed to the dialog component.
       * The dialog component will use this data to populate its fields.
       */
      data: { title: value, _id: id },
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }
  /**
   * Deletes a CSR project based on the provided ID.
   * @param id - The ID of the CSR project to delete.
   */
  deleteEvent(id) {
    // Create an array with the ID to be deleted
    let getdata = [id];
    // Call the API to delete the project
    this.makeapi.method(this.deleteApi, getdata, 'post').subscribe((data) => {
      // Check if the response status is success
      if (data.responseStatus == 'Success') {
        // Notify the user of the success
        this.notify.notifysuccess(data.responseMessage);
        // Call the list API to refresh the list
        this.csrList();
      } else {
        // Notify the user of the error
        this.notify.notifyError(data.responseMessage);
      }
    });
  }
  /**
   * Encodes the project ID and navigates to the CSR project details page.
   * @param id - The ID of the CSR project to navigate to.
   */
  eventnames(id) {
    // Encode the ID using base64 encoding and navigate to the project details page
    this.getdata.csrprojectId(btoa(id));
  }
  /**
   * Opens a dialog to view the description details.
   * @param status - The status associated with the description.
   * @param title - The title of the description.
   */
  viewDescrptionBtn(status, title) {
    // Open the RemarksComponent dialog with the provided status and title
    const dialogRef = this.dialog.open(RemarksComponent, {
      width: '390px',
      data: { _status: status, _title: title },
    });

    // After the dialog is closed, perform any necessary actions
    dialogRef.afterClosed().subscribe((result) => {
      // Handle any logic after the dialog is closed
    });
  }
  valueGet;
  butActClass;
  /**
   * Updates the status of the list and calls the ListApi function
   * to refresh the data based on the new status.
   * @param value - The status value to set.
   * @param name - The class name to apply the active status.
   */
  ststusBtn(value: number, name: string) {
    // Set the page size to 10 records per page
    this.pageSize = 10;
    this.pageNumber = 1;
    this.dataSource.paginator = this.paginator;
    // Remove the active class from all status buttons
    $('.all').removeClass('btnActive');

    // Store the new status value
    this.valueGet = value;

    // Remove the active class from the previously active status button
    $(this.butActClass).removeClass('btnActive');

    // Update the class name of the current active status button
    this.butActClass = '.' + name;

    // Add the active class to the current status button
    $(this.butActClass).addClass('btnActive');

    // Update the list object with the new status and pagination details
    if (value != 3) {
      this.list = {
        listSize: this.pageSize,
        pageNumber: this.pageNumber,
        status: this.valueGet,
      };
    } else {
      this.list = {
        listSize: this.pageSize,
        pageNumber: this.pageNumber,
      };
    }

    // Call the ListApi function to refresh the list data
    this.ListApi();
  }
}
